$('.collapsable .collapsable-trigger.js-trigger, .collapsable .collapsable-icon.js-trigger').on('click', function(ev){
	ev.preventDefault();

    var that = $(ev.currentTarget);
    var collapsable = that.closest('.collapsable');
    var isOn = collapsable.hasClass('toggle-on');
    var hiddenInput = collapsable.find('[name^="collapsible"]');

	if(isOn) {
		collapsable.removeClass('toggle-on');
        hiddenInput.attr('value', 'closed');
	} else {
		collapsable.addClass('toggle-on');
        hiddenInput.attr('value', 'open');
	}

	$(document).trigger('layout-changed');
});

$('.navigation-list .collapsable-trigger a').click(function(ev) {
    ev.preventDefault();

    var $el = $(ev.currentTarget);
    if (window.innerWidth > 1019 || $el.parents('.collapsable').hasClass('no-children')) {
        location.href = $el.attr('href');
    }
});

$('.navigation-list .collapsable-trigger').click(function(ev) {
    ev.preventDefault();

    var that = $(ev.currentTarget);
    setTimeout(function(){
        $([document.documentElement, document.body]).animate({
            scrollTop: that.offset().top - 100
        }, 250);
    }, 500);
});

$('.navigation-list.hybris .collapsable-trigger').click(function(ev) {
    ev.preventDefault();

    if (window.innerWidth < 1019) {
        var that = $(ev.currentTarget);
        var collapsable = that.closest('.collapsable');
        var isOn = collapsable.hasClass('toggle-on');

        if(isOn) {
            collapsable.removeClass('toggle-on');
        } else {
            collapsable.addClass('toggle-on');
        }

        $(document).trigger('layout-changed');
	}
});
